<footer>
    <span class="text-muted span-area" >Pie de pagina debería venir aquí.</span>
</footer>